import { Timestamp } from 'firebase/firestore';

export enum CoachTypes {
    ADD_COACH_INFO = '@coach/ADD_COACH_INFO',
    CLEAR_COACH_ERROR = '@coach/CLEAR_COACH_ERROR',
    COACH_ERROR = '@coach/COACH_ERROR',
    GET_COACH_INFO = '@coach/GET_COACH_INFO',
    GET_LIST_COACH = '@coach/GET_LIST_COACH',
    REQUEST_GET_LIST_COACH = '@coach/REQUEST_GET_LIST_COACH',
    REQUEST_UPDATE_COACH_AVAILABLE_TIME = '@coach/REQUEST_UPDATE_COACH_AVAILABLE_TIME',
    UPDATE_COACH_AVAILABLE_TIME = '@coach/UPDATE_COACH_AVAILABLE_TIME',
}

export type CoachState = {
    isLoading: boolean;
    coach: Coach[];
    error?: string;
};

export type CoachAction<Payload> = {
    type: CoachTypes;
    payload: Payload;
};

export type MeetingFirebase = {
    cancelled: boolean;
    coachId: string;
    date: Timestamp;
    time: string;
    userId: string;
};

export type AvailableTimeFirebase = {
    date: Timestamp;
    time: string;
};

export type AvailableTime = {
    date: Date;
    time: string;
    id: string;
};

export type AvailableTimeMap = Record<string, AvailableTime[]>;

export type Coach = {
    description: Record<string, string>;
    image: string;
    phoneNumber: string;
    uid: string;
    availableTime: AvailableTimeMap;
};

export type CoachReducer = (state: CoachState, actions: CoachAction<CoachState>) => CoachState;
